<template>
  <b-row>
    <b-col cols="12">
      <form-site />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import FormSite from './FormSite.vue'

export default {
  components: {
    BRow,
    BCol,
    FormSite,
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
